//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { Enums } from "../../../models/common"
import { OpSupplier, OpTask } from "../../../models/core"
import { IOpObject } from "../../../models/util/interfaces"

import { EventsNames, LocalizationHelper, CommonHelper, TypeHelper } from "../../../helpers"
import { PopupType } from "../../../helpers/popup-manager"
import { SupplierService } from '../../../services/supplier'
import { UserSessionService } from '../../../services/user-session'

import { CreateEditController, CreateEditScope } from "../../common/common.create-edit.controller"
import { LoggerService } from "../../common/common.module"
import { CreateEditInitParams } from "../../common/create-edit-popup/create-edit-popup.controller"

interface SupplierCreateEditScope extends CreateEditScope { }

export class SupplierCreateEditController extends CreateEditController {

    // #region Members

    private referenceValue: OpTask

    // #endregion


    // #region Ctor

    public constructor(
        private $scope: SupplierCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        protected userSessionService: UserSessionService,
        private supplierService: SupplierService,
        private referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // #endregion


    // #region Events

    private onInit(args: any[]): void {
        const param: any = _.first(args)
        if (param != null) {
            const createEditInitParams: CreateEditInitParams = param

            this.referenceValue = createEditInitParams ? <OpTask>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.referenceValue != null && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()
        const supplier: OpSupplier = OpSupplier.fromIOpObject(objectToSave)

        this.supplierService
            .saveSupplier(supplier)
            .then((savedObject: OpSupplier) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail(() => {
                deferred.reject()
            })

        return deferred.promise
    }

    // #endregion


    // #region Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => { this.onInit(args) }
        )
    }

    private setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.supplierSaved,
            onSubmit: null,
            onClose: null,
            referenceType: this.referenceType,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: TypeHelper.emptyString,
            type: null,

            onBulkSave: (objectToSave: IOpObject) => { return null },
            onSave: (objectToSave: IOpObject) => { return this.onSave(objectToSave) },
        }
    }

    // #endregion
}